// Initialize i18n early to ensure translations are available
// This will use the existing i18n instance if already initialized by the consuming app
// Importing this file has the side effect of initializing i18n
import "./lib/i18n";

// Also export i18n so it can be imported directly if needed
export { i18n } from "./lib/i18n";

export * from "./primitives";
export * from "./controls";
export * from "./icons";
